module.exports = __webpack_public_path__ + "img/img_business6.eeb71299.png";